type Props = {
  className?: string;
};

const Envelope = ({ className = '' }: Props) => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    className={className}
  >
    <path
      fill='#2C2E30'
      fillRule='evenodd'
      d='M19.14 5.5H4.86L12 11.05l7.14-5.55zM3.5 6.34V18c0 .28.22.5.5.5h16a.5.5 0 00.5-.5V6.34l-8.04 6.25a.75.75 0 01-.92 0L3.5 6.34zM2 6c0-1.1.9-2 2-2h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6z'
      clipRule='evenodd'
    />
  </svg>
);

export default Envelope;
